<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-18 14:28:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/purchase/components/MesDet/index.vue
-->
<template>
  <!-- milk_det鲜奶的时候true ,否则false， -->
  <div :class="{ milk_det: preCheckout.orderType === 1 }" class="mes_det">
    <div :class="{ border_top1px: preCheckout.orderType !== 1 }">
      <div
        v-if="preCheckout.warmPrompt !== null"
        class="font12 font_weight400 line_height_17 war_det text_left"
      >
        {{ preCheckout.warmPrompt }}
      </div>
      <div
        class="flex_item font12 font_weight500 colo087 line_height_17 mr_top"
      >
        <div>联系电话</div>
        <div>{{ preCheckout.contactPhone }}</div>
      </div>
      <div
        class="flex_item font12 font_weight500 colo087 line_height_17"
        @click="goNote"
      >
        <div>买家留言</div>
        <div class="colo038">
          <span :class="{ colo087: note }" class="ms">{{
            note || "建议提前和卖家协商"
          }}</span>
          <img src="@/assets/common/icon_back_b87_24@2x.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      note: localStorage.getItem("pur-note")
    };
  },
  computed: {
    preCheckout() {
      return this.$store.getters.preCheckout;
    }
  },
  methods: {
    goNote() {
      this.$emit("goNote");
    }
  }
};
</script>
<style lang="less" scoped>
.milk_det {
  margin-top: 12px;
  border-radius: 8px;
}
.mes_det {
  background: #fff;
  padding: 0 12px;
  .mr_top {
    padding-top: 24px;
  }
  .flex_item {
    padding-bottom: 27px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
      vertical-align: middle;
    }
    .ms {
      vertical-align: middle;
    }
  }
  .war_det {
    color: #bf9264;
    padding-top: 24px;
  }
}
</style>
